import React from 'react';

// Partnership Management - Influencers (User Management CSS)
const InfluencersTab = () => {
  return (
    <div className="tab-content">
      <div className="user-controls">
        <div className="search-box">
          <input type="text" placeholder="Search influencers" />
          <span className="material-icons">search</span>
        </div>
        <select className="partnership-filter-select" defaultValue="all">
          <option value="all">All Platforms</option>
          <option value="instagram">Instagram</option>
          <option value="tiktok">TikTok</option>
          <option value="youtube">YouTube</option>
          <option value="other">Other</option>
        </select>
      </div>

      <table className="users-table">
        <thead>
          <tr>
            <th>Influencer</th>
            <th>Platform</th>
            <th>Audience Size</th>
            <th>Referrals</th>
            <th>Revenue Generated</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>@example_influencer</td>
            <td>Instagram</td>
            <td>25,000</td>
            <td>50</td>
            <td>$200</td>
            <td>Active</td>
            <td>
              <div className="action-buttons">
                <button type="button" className="action-btn edit">View Profile</button>
                <button type="button" className="action-btn toggle">Disable</button>
                <button type="button" className="action-btn delete">Contact</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default InfluencersTab;

